export default __webpack_public_path__ + "assets/resizedpopularCities_3-min.0910cb6e.webp";